(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/page-provider-games/assets/javascripts/page-provider-games.js') >= 0) return;  svs.modules.push('/components/casino-react/page-provider-games/assets/javascripts/page-provider-games.js');
"use strict";


const {
  useParams
} = ReactRouterDOM;
const {
  useMemo,
  useEffect
} = React;
const {
  GridDisplayModes
} = svs.components.casino_react.common.constants;
const {
  CasinoSection
} = svs.components.casino_react.casinoSection;
const {
  FilterAndSort
} = svs.components.casino_react.filterAndSort;
const {
  cmsProviderList
} = svs.casino_react.shared.data;
const {
  useSetSearchParams
} = svs.components.casino_react.hooks;
const {
  useSearchResults
} = svs.components.casino_react.casinoStore.hooks;
const {
  SubHeader
} = svs.components.casino_react.sub_header;
const {
  setMetaTags
} = svs.components.lbUtils.setMetaTags;
const actionButtons = () => React.createElement(FilterAndSort, {
  includeProviderFilters: false
});
const PageProviderGames = () => {
  const {
    providerName
  } = useParams();
  const {
    setFilter
  } = useSetSearchParams();
  const provider = useMemo(() => cmsProviderList.find(provider => provider.model.systemName === providerName), [providerName]);
  const shouldSkipFetch = !provider;
  useEffect(() => {
    var _provider$model;
    if (provider !== null && provider !== void 0 && (_provider$model = provider.model) !== null && _provider$model !== void 0 && _provider$model.provider) {
      setFilter({
        checked: true,
        type: 'providers',
        name: provider.model.provider
      });
    }
  }, [provider]);
  const {
    games,
    error,
    isLoading,
    isFetching,
    totalGamesCount,
    fetchMore
  } = useSearchResults({
    shouldSkipFetch
  });
  useEffect(() => {
    if (provider !== null && provider !== void 0 && provider.model.provider) {
      setMetaTags({
        docTitle: "Spel fr\xE5n ".concat(provider.model.provider, " | ").concat(svs.casino_react.shared.data.seo.productName, " | Svenska Spel")
      });
    }
  }, [provider === null || provider === void 0 ? void 0 : provider.model.provider]);
  if (!provider) {
    return React.createElement("p", {
      className: "align-center margin-top-4"
    }, "Vi hittade inga resultat f\xF6r leverant\xF6r:", ' ', React.createElement("span", {
      className: "f-italic bold"
    }, providerName));
  }
  return React.createElement(React.Fragment, null, React.createElement(SubHeader, {
    title: "Spel fr\xE5n ".concat(provider.model.provider)
  }), React.createElement("div", {
    className: "page-provider-games"
  }, React.createElement(CasinoSection, {
    ActionButtons: actionButtons,
    displayMode: GridDisplayModes.GRID_UNRESTRICTED,
    fetchMore: fetchMore,
    isSearchResult: Boolean(!isFetching && !isLoading && !error && games),
    items: !isLoading && !error && games ? games : [],
    title: totalGamesCount ? "".concat(totalGamesCount, " spel") : '',
    totalGamesCount: totalGamesCount
  })));
};
setGlobal('svs.components.casino_react.pageProviderGames.PageProviderGames', PageProviderGames);

 })(window);